var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 9203"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 9202"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.16671 9.16667C8.26021 9.16667 7.37407 8.89786 6.62035 8.39424C5.86662 7.89061 5.27916 7.1748 4.93226 6.3373C4.58536 5.49981 4.49459 4.57825 4.67144 3.68917C4.84829 2.80009 5.28481 1.98342 5.9258 1.34243C6.56679 0.701439 7.38347 0.264918 8.27255 0.0880695C9.16162 -0.0887794 10.0832 0.00198588 10.9207 0.348888C11.7582 0.695789 12.474 1.28325 12.9776 2.03697C13.4812 2.7907 13.75 3.67684 13.75 4.58334C13.75 5.79891 13.2672 6.9647 12.4076 7.82424C11.5481 8.68378 10.3823 9.16667 9.16671 9.16667ZM9.16671 1.83334C8.62281 1.83334 8.09113 1.99462 7.63889 2.29679C7.18666 2.59897 6.83418 3.02846 6.62604 3.53096C6.4179 4.03345 6.36344 4.58639 6.46955 5.11983C6.57566 5.65328 6.83757 6.14328 7.22217 6.52788C7.60676 6.91247 8.09676 7.17439 8.63021 7.2805C9.16366 7.3866 9.71659 7.33215 10.2191 7.124C10.7216 6.91586 11.1511 6.56339 11.4533 6.11115C11.7554 5.65892 11.9167 5.12723 11.9167 4.58334C11.9167 3.85399 11.627 3.15452 11.1113 2.63879C10.5955 2.12307 9.89605 1.83334 9.16671 1.83334Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.4167 21.0834H0.916667C0.673551 21.0834 0.440394 20.9868 0.268485 20.8149C0.0965771 20.643 0 20.4098 0 20.1667V17.4167C0 15.4718 0.772617 13.6065 2.14788 12.2313C3.52315 10.856 5.38841 10.0834 7.33333 10.0834H11C12.9449 10.0834 14.8102 10.856 16.1854 12.2313C17.5607 13.6065 18.3333 15.4718 18.3333 17.4167V20.1667C18.3333 20.4098 18.2368 20.643 18.0648 20.8149C17.8929 20.9868 17.6598 21.0834 17.4167 21.0834ZM1.83333 19.25H16.5V17.4167C16.5 15.958 15.9205 14.5591 14.8891 13.5276C13.8576 12.4962 12.4587 11.9167 11 11.9167H7.33333C5.87464 11.9167 4.4757 12.4962 3.44425 13.5276C2.4128 14.5591 1.83333 15.958 1.83333 17.4167V19.25Z",
    fill: "#A6A6A6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyAccount);
export default __webpack_public_path__ + "static/media/MyAccount.e971262b7904a831f2820c8eb5f7d3df.svg";
export { ForwardRef as ReactComponent };